import { render, staticRenderFns } from "./SmsHistoryDatatable.vue?vue&type=template&id=1bf55b4e&scoped=true"
import script from "./SmsHistoryDatatable.vue?vue&type=script&lang=js"
export * from "./SmsHistoryDatatable.vue?vue&type=script&lang=js"
import style0 from "./SmsHistoryDatatable.vue?vue&type=style&index=0&id=1bf55b4e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bf55b4e",
  null
  
)

export default component.exports